import Swiper, { Navigation, Pagination, Lazy } from "swiper";
Swiper.use([Pagination, Navigation, Lazy]);

const initReviewsPartnersSlier = () => {
  const slider = document.querySelector(".reviewsPartners__slider");

  if (!slider) return;

  const BREAKPOINT = 750;
    let reviewsSlider = null;

    const reviewsSliderInit = () => {
      if (!reviewsSlider) {
        reviewsSlider = new Swiper(slider, {
          slidesPerView: 2,
          spaceBetween: 20,
          loop: true,
          navigation: {
            nextEl: '.reviewsPartners__navigation-button--next',
            prevEl: '.reviewsPartners__navigation-button--prev',
          },
          pagination: {
            el: '.reviewsPartners .swiper-pagination',
            type: 'fraction',
          },
          a11y: {
            enabled: true,
            prevSlideMessage: 'Переход на предыдущий слайд',
            nextSlideMessage: 'Переход на следующий слайд',
          },
        });
      }
    };

    const reviewsSliderDestroy = () => {
      if (reviewsSlider) {
        reviewsSlider.destroy();
        reviewsSlider = null;
      }
    };

    window.innerWidth >= BREAKPOINT
      ? reviewsSliderInit()
      : reviewsSliderDestroy();

    window.addEventListener('resize', () => {
      window.innerWidth >= BREAKPOINT
        ? reviewsSliderInit()
        : reviewsSliderDestroy();
    });    
};

export default initReviewsPartnersSlier;
